import MenuItems from '../Sidebar/MenuItems';

// Làm phẳng cây menu (MenuItems.AdminSchool) thành danh sách các mục có URL thật,
// để user chọn khi thêm shortcut "Xem nhanh". Bỏ qua { type: 'section' } và các
// nhóm cha không có url. Child dùng icon "caret" -> kế thừa icon của nhóm cha.
export function flattenMenu() {
    const groups = (MenuItems && MenuItems.AdminSchool) || [];
    const out = [];

    groups.forEach((item) => {
        if (!item || item.type === 'section') return;

        // Nhóm cha (hoặc mục đơn) có url -> là 1 điểm đến.
        if (item.url) {
            out.push({ label: item.title, url: item.url, icon: normalizeIcon(item.icon), group: null });
        }

        // Các mục con có url.
        const children = item.children || [];
        children.forEach((child) => {
            if (!child || !child.url) return;
            const icon = (child.icon && child.icon !== 'caret') ? child.icon : item.icon;
            out.push({ label: child.title, url: child.url, icon: normalizeIcon(icon), group: item.title });
        });
    });

    // Loại trùng url (một số nhóm cũ có thể trỏ trùng), giữ mục xuất hiện trước.
    const seen = new Set();
    return out.filter((o) => {
        if (!o.url || seen.has(o.url)) return false;
        seen.add(o.url);
        return true;
    });
}

// Bỏ các class layout thừa của sidebar (" font-18 icon-side-bar") — chỉ giữ class icon.
function normalizeIcon(icon) {
    if (!icon || typeof icon !== 'string') return 'fas fa-star';
    return icon.replace(/\s*font-18\s*/g, ' ').replace(/\s*icon-side-bar\s*/g, ' ').trim() || 'fas fa-star';
}
